module.exports = __webpack_public_path__ + "static/media/step1-backg.745da127.png";